import httpClient from '../utils/httpClient';


export const changeforgotPassword = async (requestParams) => {
    const response = await httpClient.post('/user/forgot-password', requestParams);
    return response.data;
};
